//import { useWeb3React } from '@web3-react/core'
import Web3Status from 'components/Web3Status'
//import { chainIdToBackendName } from 'graphql/data/util'
import { useIsNftPage } from 'hooks/useIsNftPage'
import { Box } from 'nft/components/Box'
import { Row } from 'nft/components/Flex'
import { useProfilePageState } from 'nft/hooks'
import { ProfilePageStateType } from 'nft/types'
import { ReactNode } from 'react'
import { NavLink, NavLinkProps, useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components/macro'

import { Bag } from './Bag'
import Blur from './Blur'
import { ChainSelector } from './ChainSelector'
//import { SearchBar } from './SearchBar'
import * as styles from './style.css'

const Nav = styled.nav`
  padding: 20px;
  width: 100%;
  height: ${({ theme }) => theme.navHeight}px;
  z-index: 2;
  @media only screen and (min-width: ${({ theme }) => `${theme.breakpoint.lg}px`}) {
    padding: 20px 0;
  }
  @media only screen and (max-width: ${({ theme }) => `${theme.breakpoint.sm}px`}) {
    padding: 20px;
  }
`

interface MenuItemProps {
  href: string
  id?: NavLinkProps['id']
  isActive?: boolean
  children: ReactNode
  dataTestId?: string
}

const MenuItem = ({ href, dataTestId, id, isActive, children }: MenuItemProps) => {
  return (
    <NavLink
      to={href}
      className={isActive ? styles.activeMenuItem : styles.menuItem}
      id={id}
      style={{ textDecoration: 'none' }}
      data-testid={dataTestId}
    >
      {children}
    </NavLink>
  )
}

const MenuItemExternal = ({ href, dataTestId, id, isActive, children }: MenuItemProps) => {
  return (
    <a
      href={href}
      className={isActive ? styles.activeMenuItem : styles.menuItem}
      id={id}
      style={{ textDecoration: 'none' }}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={dataTestId}
    >
      {children}
    </a>
  )
}

export const PageTabs = () => {
  const { pathname } = useLocation()
  //const { chainId: connectedChainId } = useWeb3React()
  //const chainName = chainIdToBackendName(connectedChainId)

  //const isPoolActive = useIsPoolsPage()
  //const isNftPage = useIsNftPage()

  //const shouldDisableNFTRoutes = useAtomValue(shouldDisableNFTRoutesAtom)

  return (
    <>
      {/*<MenuItem href="/swap" isActive={pathname.startsWith('/swap')}>
        <Trans>Swap</Trans>
      </MenuItem>
      <MenuItem href={`/tokens/${chainName.toLowerCase()}`} isActive={pathname.startsWith('/tokens')}>
        <Trans>Tokens</Trans>
  </MenuItem>
      <MenuItem href="/bridge" isActive={pathname.startsWith('/bridge')}>
        <Trans>Bridge</Trans>
      </MenuItem>
      <MenuItemExternal href="http://docs.piteas.io">
        <Trans>Docs</Trans>
      </MenuItemExternal>*/}
      {/*{!shouldDisableNFTRoutes && (
        <MenuItem dataTestId="nft-nav" href="/nfts" isActive={isNftPage}>
          <Trans>NFTs</Trans>
        </MenuItem>
      )}
      <Box display={{ sm: 'flex', lg: 'none', xxl: 'flex' }} width="full">
        <MenuItem href="/pools" dataTestId="pool-nav-link" isActive={isPoolActive}>
          <Trans>Pools</Trans>
        </MenuItem>
      </Box>
      <Box marginY={{ sm: '4', md: 'unset' }}>
        <MenuDropdown />
      </Box>*/}
    </>
  )
}

const Navbar = ({ blur }: { blur: boolean }) => {
  const isNftPage = useIsNftPage()
  const sellPageState = useProfilePageState((state) => state.state)
  const navigate = useNavigate()

  return (
    <>
      {blur && <Blur />}
      <Nav>
        <Box display="flex" height="full" flexWrap="nowrap">
          <Box className={styles.leftSideContainer}>
            {/*<Box className={styles.logoContainer}>
              <PiteasIcon
                width="48"
                height="48"
                data-testid="piteas-logo"
                className={styles.logo}
                onClick={() => {
                  navigate({
                    pathname: '/',
                    search: '',
                  })
                }}
              />
            </Box>*/}
            {/*!isNftPage && (
              <Box display={{ sm: 'flex', lg: 'none' }}>
                <ChainSelector leftAlign={true} />
              </Box>
            )*/}
            <Row display={{ sm: 'none', lg: 'flex' }}>
              <PageTabs />
            </Row>
          </Box>
          {/*<Box className={styles.searchContainer}>
            <SearchBar />
          </Box>*/}
          <Box className={styles.rightSideContainer}>
            <Row gap="8">
              {/*<Box position="relative" display={{ sm: 'flex', navSearchInputVisible: 'none' }}>
                <SearchBar />
              </Box>*/}
              {isNftPage && sellPageState !== ProfilePageStateType.LISTING && <Bag />}
              {!isNftPage && (
                <Box /*display={{ sm: 'none', lg: 'flex' }}*/>
                  <ChainSelector />
                </Box>
              )}

              <Web3Status />
              {/*<Box marginY={{ sm: '4', md: 'unset' }}>
                <MenuDropdown />
              </Box>*/}
            </Row>
          </Box>
        </Box>
      </Nav>
    </>
  )
}

export default Navbar
